import { useEffect, useState } from 'react';
import { useCookieConsent } from '../context/CookieConsentContext';
import { Modal, Button } from './ComponentLibrary';
import './CookieSettingsModal.css';

const CATEGORIES = [
  {
    key: 'functional',
    title: 'Functional',
    description: "Remembers things like your theme, and enables the Google Sign-In prompt.",
  },
  {
    key: 'analytics',
    title: 'Analytics',
    description: 'Google Analytics and Firebase help us see what’s working and what isn’t.',
  },
  {
    key: 'marketing',
    title: 'Marketing',
    description: 'Used for ads and campaigns. Nothing uses this yet, reserved for later.',
  },
];

function Switch({ id, checked, onChange, label }) {
  return (
    <label className="cookie-switch" htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        aria-label={label}
      />
      <span className="cookie-switch__track" aria-hidden="true">
        <span className="cookie-switch__thumb" />
      </span>
    </label>
  );
}

function CookieSettingsModal() {
  const { isSettingsOpen, closeSettings, consent, acceptAll, rejectNonEssential, savePreferences } =
    useCookieConsent();
  const [selections, setSelections] = useState({ functional: false, analytics: false, marketing: false });

  // Re-sync local toggles with the stored decision each time the modal opens.
  useEffect(() => {
    if (isSettingsOpen) {
      setSelections({
        functional: Boolean(consent?.functional),
        analytics: Boolean(consent?.analytics),
        marketing: Boolean(consent?.marketing),
      });
    }
  }, [isSettingsOpen, consent]);

  const toggle = (key) => (value) => setSelections((prev) => ({ ...prev, [key]: value }));

  const handleAcceptAll = () => {
    acceptAll();
    closeSettings();
  };

  const handleRejectNonEssential = () => {
    rejectNonEssential();
    closeSettings();
  };

  const handleSave = () => {
    savePreferences(selections);
    closeSettings();
  };

  const footer = (
    <div className="cookie-settings__footer">
      <Button variant="secondary" onClick={handleRejectNonEssential}>
        Reject Non-Essential
      </Button>
      <div className="cookie-settings__footer-actions">
        <Button variant="secondary" onClick={handleAcceptAll}>
          Accept All
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save Preferences
        </Button>
      </div>
    </div>
  );

  return (
    <Modal
      isOpen={isSettingsOpen}
      onClose={closeSettings}
      title="Cookie Preferences"
      size="sm"
      footer={footer}
    >
      <p className="cookie-settings__intro">
        Choose which cookies NaijaNest can use. You can change this anytime from the site footer.
      </p>

      <div className="cookie-cat-row">
        <div className="cookie-cat-row__text">
          <h4>Essential</h4>
          <p>Required to log in and keep the site secure. Can&rsquo;t be switched off.</p>
        </div>
        <span className="cookie-locked-pill">Always on</span>
      </div>

      {CATEGORIES.map(({ key, title, description }) => (
        <div className="cookie-cat-row" key={key}>
          <div className="cookie-cat-row__text">
            <h4>{title}</h4>
            <p>{description}</p>
          </div>
          <Switch
            id={`cookie-cat-${key}`}
            checked={selections[key]}
            onChange={toggle(key)}
            label={title}
          />
        </div>
      ))}
    </Modal>
  );
}

export default CookieSettingsModal;
